/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2509
 */

module.exports = function (e) {
  this.__data__.set(e, "__lodash_hash_undefined__")
  return this
}
